import { render, staticRenderFns } from "./Incomes.vue?vue&type=template&id=90148592&scoped=true"
import script from "./Incomes.vue?vue&type=script&lang=js"
export * from "./Incomes.vue?vue&type=script&lang=js"
import style0 from "./Incomes.vue?vue&type=style&index=0&id=90148592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90148592",
  null
  
)

export default component.exports